// Ticks a sale countdown. Falls back to the next local midnight when no future end date is set.
class SCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.units = {
      h: this.querySelector('[data-unit="h"]'),
      m: this.querySelector('[data-unit="m"]'),
      s: this.querySelector('[data-unit="s"]'),
    };
    const parsed = Date.parse(this.dataset.end || '');
    this.fixedEnd = Number.isFinite(parsed) ? parsed : null;
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #target() {
    const now = Date.now();
    if (this.fixedEnd && this.fixedEnd > now) return this.fixedEnd;
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
  }

  #tick() {
    const remaining = Math.max(0, this.#target() - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');
    if (this.units.h) this.units.h.textContent = pad(hours);
    if (this.units.m) this.units.m.textContent = pad(minutes);
    if (this.units.s) this.units.s.textContent = pad(seconds);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
